import { createFileRoute } from '@tanstack/react-router';

import Page from '@/screens/chat/skills/page';

export const Route = createFileRoute('/_app/_chat/skills/')({
  component: Page,
});
